var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString, IsEnum, IsOptional } from 'class-validator';
import { CancellationOrigin } from '../enums/cancellation-origin.enum.js';
/**
 * Body for `POST /appointments/:id/cancel` (TM-9064, slice 5). The
 * `origin` distinguishes a patient-initiated cancellation (US 9: the
 * practice records that the patient called and cancelled) from a
 * practice-initiated one. Only `PATIENT` is fee-eligible downstream;
 * `PRACTICE` is audited but never charged. Optional — absent ⇒
 * `PRACTICE`, the conservative default for legacy clients.
 */
export class CancelAppointmentDto {
    origin;
    /**
     * When the patient's Absage reached the practice (TM-9737) — the voicemail of 7:00
     * the office enters at 9:30. Only with `origin = PATIENT`; absent ⇒ now. Neither in
     * the future nor before the appointment was booked.
     */
    receivedAt;
}
__decorate([
    IsOptional(),
    IsEnum(CancellationOrigin),
    __metadata("design:type", String)
], CancelAppointmentDto.prototype, "origin", void 0);
__decorate([
    IsOptional(),
    IsDateString(),
    __metadata("design:type", String)
], CancelAppointmentDto.prototype, "receivedAt", void 0);
//# sourceMappingURL=cancel-appointment.dto.js.map